import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { logger, LogCategory } from './utils/logger';

// Initialize React app
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

try {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  logger.error(LogCategory.UI, 'Critical error during app render', error, 'index');
  
  // Render a fallback UI
  root.render(
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ color: 'red' }}>Application Failed to Start</h1>
      <p>Error: {(error as Error).message}</p>
      <pre style={{ background: '#f5f5f5', padding: '10px', fontSize: '12px' }}>
        {(error as Error).stack}
      </pre>
    </div>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
